const constructFullName = (stringArray: Array<null | string>): string => {
  const cleanedStrings = stringArray.filter((value) => value);
  return cleanedStrings.join(' ');
};

export default constructFullName;
